(() => {
  // app/scripts/assessment.js
  customElements.define("assessment-form", class extends HTMLElement {
    constructor() {
      super();
    }
    async connectedCallback() {
      this.customer = JSON.parse(this.querySelector(".jsProductMetafield").innerText)?.customer;
      this.product_url = JSON.parse(this.querySelector(".jsProductMetafield").innerText)?.product_url;
      this.dataForm = this.getAttribute("data-form");
      if (this.dataForm) {
        this.classList.add("is-loading");
        this.data = await this.getFormData();
        this.classList.remove("is-loading");
      } else {
        this.data = JSON.parse(this.querySelector(".jsProductMetafield").innerText)?.questions;
      }
      console.log("this.data :>> ", this.data);
      this.setAttribute("data-form", JSON.stringify(this.data));
      this.form = this.querySelector(".form-assessment");
      this.submit = this.querySelector(".progSuccess");
      if (this.dataForm) {
        let successText = this.submit.querySelector(".success-text");
        successText.innerText = "Update Your Form";
      }
      this.renderInputs();
      this.submit && this.submit.addEventListener("click", this.submitForm.bind(this));
      if (this.dataForm) {
        let assessmentInputs = document.querySelectorAll("assessment-input");
        assessmentInputs && assessmentInputs.forEach((input) => {
          input.handleInputDependent();
        });
      }
      this.startForm = this.querySelector(".start");
      this.startForm && this.startForm.addEventListener("click", () => {
        this.classList.remove("popup-pom");
      });
      this.endForm = this.querySelector(".end");
      this.endForm && this.endForm.addEventListener("click", () => {
        if (this.customer !== "null") {
          this.style.display = "none";
          let atcButton = document.querySelector(".assessment-atc");
          if (atcButton) {
            let formTrigger = atcButton?.parentElement.querySelector("assessment-trigger");
            formTrigger.style.display = "none";
            atcButton.style.display = "block";
            atcButton?.click();
            atcButton.classList.remove("assessment-atc");
          }
        } else {
          let atcButton = document.querySelector(".assessment-atc");
          if (atcButton) {
            let formTrigger = atcButton?.parentElement.querySelector("assessment-trigger");
            formTrigger.style.display = "none";
            atcButton.style.display = "block";
            atcButton?.click();
            atcButton.classList.remove("assessment-atc");
          }
          setTimeout(() => {
            localStorage.setItem("formSubmit", JSON.stringify({
              ...this.data,
              product_url: this.product_url
            }));
            window.location.replace(`/account/login`);
          }, 500);
        }
      });
    }
    renderInputs() {
      this.data?.inputs?.map((input, index) => {
        let assessmentInput = document.createElement("assessment-input");
        assessmentInput.classList.add("question", "progressQuestion");
        if (input.value) {
          assessmentInput.classList.add("input-selected");
          assessmentInput.setAttribute("selected", true);
          assessmentInput.setAttribute("data-value-submitted", input.value);
        }
        if (input.require) {
          assessmentInput.classList.add("input-required");
        }
        if (input.dependent) {
          assessmentInput.classList.add("input-dependent");
        }
        assessmentInput.setAttribute("data-type", input.type);
        assessmentInput.setAttribute("data-handle", input.handle);
        assessmentInput.id = `questionContainer-${input.id}`;
        let template = `
          <div class="questionBox" >
            <div class="questionNum">
                <span class="num"></span>
                <span class="checked">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.09082 5.64577L4.41098 9.22531L10.909 2.72732" stroke="white" stroke-width="1.09091" stroke-linecap="round"/>
                    </svg>    
                </span>
            </div>
            <div class="questionInner question-${input.type} ${(input.type === "checkbox" || input.type === "radio") && "question-input-box"}">
              <div class="row yesnoRowLabel">
                  <span>
                      <p>${input.title}${input.require ? "<span style='color: red;'> *</span>" : ""}</p>
                  </span>
                  ${input.description ? `
                    <span>
                      ${input.description}
                    </span>
                  ` : ""}
                  <span class="handle-error" style="display: none">
                      Invalid Value
                  </span>
              </div>
              <div class="row yesNoRow">
                ${this.renderOptions(input)}
              </div>
            </div>
          </div>
        `;
        if (input.helpText) {
          template += `
            <div class="questionBox question-note">
              <div class="wrapper">
                <span className="icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1301_10807)">
                    <circle cx="10.0001" cy="9.99997" r="9.09091" fill="#26A4AA"/>
                    <path d="M10 16L10 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M10 5V4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_1301_10807">
                    <rect width="20" height="20" fill="white"/>
                    </clipPath>
                    </defs>
                  </svg>
                </span>
                <span className="text">
                  ${input.helpText}
                </span>
              </div>
            </div>
          `;
        }
        assessmentInput.innerHTML = template;
        this.form.appendChild(assessmentInput);
      });
      let assessmentProgress = document.querySelector("assessment-progress");
      assessmentProgress?.updateProgress();
    }
    renderOptions(input) {
      let options = "";
      switch (input.type) {
        case "consentient":
          input.options?.map((option, index) => {
            options += `
              <input class="input-form" type="radio" name="questions[${input.id}]" id="question-${option.value.replace(" ", "").toLowerCase()}-${input.id}" value="${option.value}" ${input.value && input.value == option.value && "checked"}>
              <label for="question-${option.value.replace(" ", "").toLowerCase()}-${input.id}">${option.label}</label>
            `;
          });
          break;
        case "text":
          options += `
              <input ${input.value && `value="${input.value}"`} class="input-form" type="text" name="questions[${input.id}]" id="question-text-${input.id}">
          `;
          break;
        case "number":
          options += `
                <input ${input.value && `value="${input.value}"`} class="input-form" type="number" name="questions[${input.id}]" id="question-text-${input.id}" min=0>
            `;
          break;
        case "checkbox":
          input.options?.map((option, index) => {
            options += `
                  <div class="row">
                    <input ${input.value && input.value.includes(option.value) && "checked"} class="input-form" value="${option.value}" type="checkbox" name="questions[${input.id}]" id="question-checkbox-${option.id}" min=0>
                    <label for="question-checkbox-${option.id}">${option.label}</label>
                  </div>
                `;
          });
          break;
        case "radio":
          input.options?.map((option, index) => {
            options += `
                    <div class="row">
                      <input ${input.value && input.value == option.value && "checked"} class="input-form" value="${option.value}" type="radio" name="questions[${input.id}]" id="question-radio-${option.id}" min=0>
                      <label for="question-radio-${option.id}">${option.label}</label>
                    </div>
                  `;
          });
          break;
        case "select":
          let selectOptions = "";
          input.options?.map((option, index) => {
            selectOptions += `
                <option ${input.value && input.value === option.value && "selected"} value="${option.value}">${option.label}</option>
              `;
          });
          options += `
              <select name="questions[${input.id}]" class="input-form" id="question-select-${input.id}">
                <option selected disabled>-- Select Option --</option>
                ${selectOptions}
              </select>
            `;
          break;
        default:
          break;
      }
      return options;
    }
    async submitForm() {
      let formData = new FormData(this.form);
      let formObj = this.serialize(formData);
      this.submit.classList.add("is-loading");
      this.data.inputs = this.data.inputs.map((input) => {
        return {
          ...input,
          value: formObj[`questions[${input.id}]`]
        };
      });
      if (this.customer !== "null") {
        const response = await fetch(`https://pharmacy.wayspharmacy.co.uk/api/v1/consentient-forms`, {
          body: JSON.stringify({
            customer: {
              email: this.customer
            },
            formData: this.data
          }),
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          }
        }).then((res) => res.json()).then((data) => {
          data = data.data;
          if (data.id) {
            if (this.startForm) {
              this.classList.add("popup-finish");
            } else {
              this.style.display = "none";
              let atcButton = document.querySelector(".assessment-atc");
              if (atcButton) {
                let formTrigger = atcButton?.parentElement.querySelector("assessment-trigger");
                formTrigger.style.display = "none";
                atcButton.style.display = "block";
                atcButton?.click();
                atcButton.classList.remove("assessment-atc");
              }
            }
          } else {
            this.handleFormError(data.formData);
          }
          this.submit.classList.remove("is-loading");
        });
      } else {
        const response = await fetch(`https://pharmacy.wayspharmacy.co.uk/api/v1/consentient-forms-validate`, {
          body: JSON.stringify({
            customer: {
              email: this.customer
            },
            formData: this.data
          }),
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          }
        }).then((res) => res.json()).then((data) => {
          data = data.data;
          if (!data.error) {
            if (this.startForm) {
              this.classList.add("popup-finish");
            } else {
              let atcButton = document.querySelector(".assessment-atc");
              if (atcButton) {
                let formTrigger = atcButton?.parentElement.querySelector("assessment-trigger");
                formTrigger.style.display = "none";
                atcButton.style.display = "block";
                atcButton?.click();
                atcButton.classList.remove("assessment-atc");
              }
              setTimeout(() => {
                localStorage.setItem("formSubmit", JSON.stringify({
                  ...this.data,
                  product_url: this.product_url
                }));
                window.location.replace(`/account/login`);
              }, 500);
            }
          } else {
            this.handleFormError(data.formData);
          }
          this.submit.classList.remove("is-loading");
        });
      }
    }
    async getFormData() {
      try {
        const response = await fetch(`https://pharmacy.wayspharmacy.co.uk/api/v1/consentient-forms?email=${this.customer}`);
        const responseData = await response.json();
        if (!responseData || !responseData.data) {
          throw new Error("Invalid response data");
        }
        const form = responseData.data.find((item) => item.formData.handle === this.dataForm);
        if (!form) {
          console.warn("Form data not found");
          return null;
        }
        return form.formData;
      } catch (error) {
        console.error("Error retrieving form data:", error);
        return null;
      }
    }
    serialize(data) {
      let obj = {};
      for (let [key, value] of data) {
        if (obj[key] !== void 0) {
          if (!Array.isArray(obj[key])) {
            obj[key] = [obj[key]];
          }
          obj[key].push(value);
        } else {
          obj[key] = value;
        }
      }
      return obj;
    }
    handleFormError(data) {
      if (!data)
        return;
      let invalidInputs = data.inputs.filter((input) => input.error);
      if (!invalidInputs)
        return;
      invalidInputs?.map((input) => {
        let inputField = document.querySelector(`#questionContainer-${input.id}`);
        if (inputField) {
          inputField.classList.add("handle-error-active");
          let error = inputField.querySelector(".handle-error");
          error.innerText = "* " + data.error;
        }
      });
    }
  });
  customElements.define("assessment-input", class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.inputs = this.querySelectorAll(".input-form");
      this.type = this.getAttribute("data-type");
      this.handle = this.getAttribute("data-handle");
      this.valueSubmitted = this.getAttribute("data-value-submitted");
      this.inputs && this.inputs?.forEach((input) => {
        input.addEventListener("change", this.handleOnChange.bind(this));
      });
    }
    handleOnChange(e) {
      this.handleInputDependent(e.target.value);
      this.classList.remove("handle-error-active");
      let assessmentProgress = document.querySelector("assessment-progress");
      let typeCheck = ["number", "checkbox", "text"];
      let currentInput = e.currentTarget;
      let flagSuccess = true;
      if (typeCheck.includes(this.type)) {
        if (this.type === "checkbox") {
          let name = currentInput.name;
          let inputsByName = Array.from(this.querySelectorAll(`[name="${name}"]`));
          let checkSelect = inputsByName?.find((elm) => elm.checked);
          if (!checkSelect) {
            flagSuccess = false;
          }
        } else {
          if (currentInput.value === "") {
            flagSuccess = false;
          }
        }
      }
      if (flagSuccess) {
        this.classList.add("input-selected");
        this.setAttribute("selected", true);
      } else {
        this.classList.remove("input-selected");
        this.removeAttribute("selected");
      }
      assessmentProgress?.updateProgress();
    }
    handleInputDependent(value) {
      let assessmentForm = document.querySelector("assessment-form");
      let formData = JSON.parse(assessmentForm.getAttribute("data-form"));
      let dependentInputs = formData.inputs.filter((item) => {
        return item.dependent && item.dependent.handle === this.handle;
      });
      if (dependentInputs) {
        dependentInputs?.map((dependentInput) => {
          let valueDependent = value || this.valueSubmitted;
          let questionInput = document.querySelector(`#questionContainer-${dependentInput.id}`);
          if (dependentInput?.dependent.value === valueDependent) {
            questionInput?.classList.remove("input-dependent");
          } else {
            questionInput?.classList.add("input-dependent");
          }
        });
      }
    }
  });
  customElements.define("assessment-progress", class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.progressBar = this.querySelectorAll(".bar");
      let totalInput = document.querySelectorAll("assessment-input")?.length;
      let totalInputField = this.querySelector(".totalQuestion");
      if (totalInputField) {
        totalInputField.innerText = totalInput;
      }
      this.updateProgress();
    }
    updateProgress() {
      let totatSelected = document.querySelectorAll("assessment-input[selected=true]:not([class*='input-dependent']).input-required")?.length;
      let totalInput = document?.querySelectorAll("assessment-input:not([class*='input-dependent']).input-required")?.length;
      let totalSelectedField = this.querySelector(".progressNum");
      if (totalSelectedField) {
        totalSelectedField.innerText = totatSelected;
      }
      let totalInputField = this.querySelector(".totalQuestion");
      if (totalInputField) {
        totalInputField.innerText = totalInput;
      }
      this.progressBar?.forEach((bar) => {
        bar.style.width = `${totatSelected / totalInput * 100}%`;
      });
      if (totatSelected === totalInput) {
        this.classList.add("complete");
      } else {
        this.classList.remove("complete");
      }
    }
  });
  customElements.define("assessment-trigger", class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.productUrl = this.getAttribute("data-product-url");
      this.dataForm = this.getAttribute("data-form");
      this.addEventListener("click", this.renderPopup.bind(this));
      this.mainAtcBtn = this.parentElement.querySelector(".add-to-cart") || this.parentElement.querySelector("#stickyAddCartBtn");
    }
    renderPopup() {
      fetch(`${this.productUrl || ""}?section_id=popup-assessment`).then((res) => res.text()).then((html) => {
        let exist = document.querySelector("#shopify-section-popup-assessment");
        exist && exist.remove();
        let element = document.createElement("div");
        element.innerHTML = html;
        if (this.dataForm) {
          element.querySelector("assessment-form")?.setAttribute("data-form", this.dataForm);
        }
        document.body.appendChild(element);
      });
      this.mainAtcBtn?.classList?.add("assessment-atc");
    }
  });
})();
